<template>
  <CustomTable :columns="columnsToVisit" :openModal="handleOpen" type="Visits" />
  <!-- 弹出框 -->
  <Gauge ref="gDetail" :params="detailQuery" />
  <!-- 问卷结果iframe -->
  <Info ref="infoRef" :url="scaleResultsUrl"></Info>
</template>

<script setup>
import CustomTable from './CustomTable.vue'
import { columnsToVisit } from '@/components/PatientFile/ModalBody/todo/config'
import { reactive, ref } from 'vue'
import Gauge from '@/views/WorkPlace/Container/Gauge/components/gDetail.vue'
import { message } from 'ant-design-vue'
import Info from '@/views/WorkPlace/Container/chat/components/ScaleResults/Info.vue'

// 查看量表详情
const gDetail = ref(null)
const detailQuery = reactive({
  surveyId: null,
  surveySendId: null
})
const scaleResultsUrl = ref('')
const infoRef = ref(null)

const handleOpen = data => {
  const { surveyId, surveyType, url, businessId } = data.record
  if (surveyType !== 1) {
    if (!url) return message.warning('当前量表暂不支持查看！')
    scaleResultsUrl.value = `${url}&mood=readPretty&surveyType=${surveyType}`
    return infoRef.value.showDrawer()
  }
  gDetail.value.gDetailVisible = true
  detailQuery.surveyId = surveyId
  detailQuery.surveySendId = businessId
}
</script>

<style lang="scss" scoped></style>
